import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { DownloadIcon } from "../../../../components/icons";
import type { IApplication } from "../../../../hooks/reactQueryHooks/useApplications";
import { ExportCacheItemForm } from "../forms/ExportCacheItem";

interface IProps {
  applications: IApplication[];
}

const ExportCacheItem: React.FC<IProps> = ({ applications }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  return (
    <>
      {show && (
        <ExportCacheItemForm
          onCancel={handleClose}
          applications={applications}
        />
      )}
      <Button
        onClick={handleOpen}
        className="fw-bold flex-shrink-0 d-flex align-items-center gap column-gap-2 ms-sm-5"
      >
        <DownloadIcon />
        Export
      </Button>
    </>
  );
};

export { ExportCacheItem };
